const T = require("react").PropTypes;
const Config = require("../../Config.js");

/**
 * Specifies metadata for store budget uploads.
 * 
 * Type gives us a shape to use in validating data passed to the component.
 * 
 * GetSpecData() generates a "Data" object for a MetadataSpec.
 */
const GeocodingImporter = {
    // Factory method
    GetSpecData() {
        const spec = {
            SampleFileURL: Config.RootApiUrl + "content/AddressTemplate.csv",
            IsComplete: true,
            Arg: null
        };

        return spec;
    },
    // This should mirror the spec type.
    Type: T.shape({
        SampleFileURL: T.string.isRequired
    })
};

module.exports = GeocodingImporter;


// WEBPACK FOOTER //
// ./src/types/metadata/GeocodingImporter.js